<template>
  <div class="service_page">
    <div class="show_btn" :class="{ 'hide': isShowing }">
      <img :src="require('@/assets/onlineCustomer/img_1.png')" @click="showBtn">
    </div>
    <div class="hide_btn" :class="{ 'slide-in': isShowing && !isRouteChanging, 'slide-out': isSlidingOut, 'no-transition': isRouteChanging }">
      <img class="avatar" :src="require('@/assets/onlineCustomer/img_2.png')">
      <div class="show_btn_content">
        <div class="head" @click="hideBtn">
          在线客服
          <img :src="require('@/assets/onlineCustomer/left.png')">
        </div>
        <div>扫一扫微信沟通</div>
        <img :src="require('@/assets/onlineCustomer/qq_code.png')" class="qq_code">
        <img :src="require('@/assets/onlineCustomer/server_1.png')" class="server_img" @click="toQQ('tencent://message/?uin=3415132171&Site=%E5%A5%BD%E5%A4%A7%E5%A4%AB%E6%95%99%E8%82%B2&Menu=Yes&Exe=QQ')">
        <img :src="require('@/assets/onlineCustomer/server_2.png')" class="server_img" @click="toQQ('tencent://message/?uin=3415132171&Site=%E5%A5%BD%E5%A4%A7%E5%A4%AB%E6%95%99%E8%82%B2&Menu=Yes&Exe=QQ')">
        <img :src="require('@/assets/onlineCustomer/server_3.png')" class="server_img" @click="toQQ('tencent://message/?uin=3237098625&Site=%E5%A5%BD%E5%A4%A7%E5%A4%AB%E6%95%99%E8%82%B2&Menu=Yes&Exe=QQ')">
        
      </div>
    </div>

  </div>
</template>

<script>

export default {
  name: 'OnlineCustomer',
  components: {
  },
  props: {
  },
  data() {
    return {
      isShowing: false,
      isSlidingOut: false,
      isRouteChanging: false,
    }
  },
  mounted() {
    this.$router.afterEach(() => {
      if (this.isShowing) {
        this.isRouteChanging = true
        this.isShowing = false
        this.isSlidingOut = false
      }
    })
  },
  methods: {
    showBtn(){
      this.isRouteChanging = false
      this.isSlidingOut = false
      this.isShowing = true
    },
    hideBtn(){
      this.isSlidingOut = true
      setTimeout(() => {
        this.isShowing = false
        this.isSlidingOut = false
      }, 500)
    },
    toQQ(url){
      window.open(url)
    },

  }
}
</script>
<style scoped lang="scss">
.service_page{
  position: fixed;
  top: 50%;
  transform: translateY(-50%);
  left: 0;
  z-index: 9999;

  .show_btn{
    transition: opacity 0.3s ease;
    &.hide{
      opacity: 0;
      pointer-events: none;
    }
  }

  .hide_btn{
    width: 120px;
    position: absolute;
    left: -120px;
    top: 50%;
    transform: translateY(-50%);
    transition: left 0.7s ease;
    
    &.slide-in{
      left: 0;
    }
    
    &.slide-out{
      left: -120px;
    }
    
    &.no-transition{
      transition: none !important;
      left: -120px;
    }

    .avatar{
      margin: 0 auto;
    }
    .show_btn_content{
      background-color: #fff;
      width: 100%;
      margin-top: -15px;
      padding-bottom: 10px;
      position:relative;
      z-index: 1;
      >div{
        text-align: center;
      }
      .head{
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 15px 0;
        font-weight: bold;
        border-bottom: 1px solid #e5e5e5;
        margin-bottom: 15px;
        cursor: pointer;
        img{
          margin-left: 10px;
        }
      }
      .qq_code{
        margin: 0 auto 15px;
      }
      .server_img{
        margin: 0 auto 10px;
        cursor: pointer;
      }
    }
  }
}


</style>
